<template>
  <div class="main">
    <van-dialog
      v-model="dialogshow"
      show-cancel-button
      confirm-button-text="继续练习"
      cancel-button-text="关闭练习"
      :beforeClose="beforeperjiaojuanClose"

    >
      <div class="jjclass">
        <div>已答题：{{doanswer}}</div>
        <div @click="choseanswer('no')">未答题：<span style="color:red;">{{undoanswer}}</span></div>
        <div >答对题数：<span style="color:green;">{{dts}}</span></div>
        <div >未对题数：<span style="color:red;">{{wdts}}</span></div>
      </div>
    </van-dialog>
    <van-nav-bar
      right-text="交卷"
      left-arrow
      @click-left="back"
    >
      <template #title>
        <div class="title" @click="titleTap()">
          {{ type.text }}<van-icon name="arrow-down" color="#7d7e80" size="12" />
        </div>
      </template>
      <template #right>
        <van-icon name="clock" color="#7469F8" />
        <div v-html="dtime"></div>
      </template>
    </van-nav-bar>
    <div class="name-num" @click="popupshow">
      <p>{{title}}</p>
      <div><span>{{ curIndex + 1 }}</span>/{{ curTotal }}</div>
    </div>
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <div class="content">
      <!-- 单选题 -->
      <single-opt ref="ceopt"  v-if="data[type.value].examtypeid == '1' " :multiple="false" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 多选题 -->
      <single-opt ref="ceopt"   v-if="data[type.value].examtypeid == '2'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 判断题 -->
      <true-or-false ref="ceopt"  v-if="data[type.value].examtypeid == '3'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in ref="ceopt" v-if="data[type.value].examtypeid == '4'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 问答题
      <q-and-a v-if="data[type.value].examtypeid == '5'" @saveda="saveanswer" :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />
      -->
      <!-- 理解题 -->
      <comprehension ref="ceopt" v-if="data[type.value].examtypeid == '6'" @saveda="saveanswer" :paper-id="paperId" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 不定项选择题 -->
      <single-opt ref="ceopt" v-if="data[type.value].examtypeid == '7'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!--排序题 8-->
      <px-info ref="ceopt" v-if="data[type.value].examtypeid == '8'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in ref="ceopt" v-if="data[type.value].examtypeid == '9'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 固定题型以外都已问答题展示
      <q-and-a v-if="parseInt(data[type.value].examtypeid==null || data[type.value].examtypeid=='' ? '0' : data[type.value].examtypeid) > 9" @saveda="saveanswer" :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />
    -->
    </div>

    <!-- 题型 -->
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        title="题型"
        show-toolbar
        :columns="typeoption"
        @confirm="onConfirm"
      />
    </van-popup>

    <van-tabbar v-model="active" active-color="#7d7e80">
      <van-tabbar-item icon="arrow-left" @click="alterNum('last')">上一题</van-tabbar-item>
      <van-tabbar-item icon="share" @click="prejiaojuan">交卷</van-tabbar-item>
      <van-tabbar-item icon="arrow" @click="alterNum('next')">下一题</van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="popshow" position="left" style=" width: 30%;height:100% ">
      <div style="display: flex;flex-direction: column;padding-left: 5px;padding-right: 5px;">
        <span style="margin-top: 6.25rem;">选择题目：</span>
        <van-button plain type="info" @click="choseanswer('yes')">已答题({{doanswer}})</van-button>
        <van-button plain type="danger" @click="choseanswer('no')">未答题({{undoanswer}})</van-button>
        <van-button plain type="default" @click="choseanswer('all')">全部</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import singleOpt from './lianxicomm/singleOpt'
  import TrueOrFalse from './lianxicomm/trueOrFalse.vue'
  import fillIn from './lianxicomm/fillIn.vue'
  import qAndA from './lianxicomm/qAndA.vue'
  import PxInfo from './lianxicomm/pxinfo.vue'
  import comprehension from './lianxicomm/comprehension.vue'
  import sf from '../../utils/somefun.js';
  import { Dialog } from 'vant';

  var timectrl = sf.tc;
  export default {
    components: {
      singleOpt,
      TrueOrFalse,
      fillIn,
      qAndA,
      comprehension,
      PxInfo
    },
    data() {
      return {
        type: {
          text: '单选题',
          value: 0
        },
        wdtype: 11111,
        wdtindex: 11111,
        curIndex: 0,
        curTotal: 0,
        active: 0,
        show: false,
        loading:true,
        typeoption: [],
        dialogimgsshow:false,
        dialogshow:false,
        imgsupsucess:{},
        imgsuptotal:0,
        imgsupsucnum:0,
        index:0,
        doanswer:0,
        undoanswer:0,
        ystime:0,
        isautojj: false,
        jiaojuaning: false,
        bbaractive: 0,
        title: '',
        lxactive: 0,
        data: [{PaperInfotabList:[],examtypedesc:'',examtypeid:''}],
        exam_time: '',
        paperId: 0,
        paperDesc: '',
        kcmc: '',
        dtime: '',
        popshow: false,
        timer:null,
        newDate:null,
        dts:0,
        wdts:0,
      }
    },
    created() {
      this.newDate = this.dateFormat(new Date());
      this.inittime();
      let from = this.$route.params.from;
      let zthat = this;
      zthat.title=from.kcmc;
      this.$ajax.put('/student/lianxi/studentlianxi/',from).then(function (rep) {
        if (rep.code == 500 || rep.code == 401) {
          zthat.$toast.fail(rep.msg);
          zthat.$router.push('/studentmain');
        } else {
          console.log('post kstm>>>', rep);
          rep = rep.data;
          zthat.data = rep.typeoption;
          for (let i = 0; i < zthat.data.length; i++) {
            zthat.typeoption.push({text:zthat.data[i].examtypedesc,value:i});
            //默认一个
            if(i==0){
              zthat.type.text=zthat.data[i].examtypedesc;
              zthat.type.value=i;
              zthat.curTotal = zthat.data[i].PaperInfotabList.length;
            }
          }
          console.log('zdata', zthat.data);
        }
        zthat.loading = false
      });
    },
    methods: {
      calcActive() {
        this.curTotal = this.data[this.type.value].PaperInfotabList.length
      },
      inittime () {
        this.timer = setInterval(() => {
          let _this = this;
          let offset = 1;
          offset = Math.floor((Date.now() - Date.parse(_this.newDate)) / 1000);

          let secLeft = offset % 60;
          let minLeft = Math.floor(offset / 60) % 60;
          let hourLeft = Math.floor(offset / 60 / 60) % 24;

          // 补0操作
          secLeft = (secLeft < 10 ? '0' : '') + secLeft;
          minLeft = (minLeft < 10 ? '0' : '') + minLeft;
          hourLeft = (hourLeft < 10 ? '0' : '') + hourLeft;

          // 4）拼接时间格式，写入timehtml
          _this.dtime = hourLeft + '时' + minLeft + '分' + secLeft + '秒';

        }, 1000)
      },
      //时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
      dateFormat:function(time) {
        var date=new Date(time);
        var year=date.getFullYear();
        /* 在日期格式中，月份是从0开始的，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
        var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
        var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
        var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
        // 拼接
        return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
      },
      aletrType(type) {
        if (type === 'next') {
          if (this.type.value < this.data.length && this.type.value != this.data.length-1) {
            this.curIndex = 0
            this.type.value++
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive();
          } else {
            this.$toast('没有更多')
          }
        }
        if (type === 'last') {
          if (this.type.value > 0) {
            this.type.value--
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive()
            this.curIndex = this.curTotal - 1
          } else {
            this.$toast('没有更多')
          }
        }

      },
      alterNum(type) {
        if (type === 'next') {
          if (this.curIndex < this.curTotal - 1) {
            this.curIndex++
          } else {
            // 进入下一题型
            this.aletrType(type)
          }
        }
        if (type === 'last') {
          if (this.curIndex > 0) {
            this.curIndex--
          } else {
            this.aletrType(type)
          }
        }
        this.saveanswer();
        this.$refs.ceopt.changisda();
        console.log("下一题长度显示：",this.data);
        console.log(type)
      },
      titleTap() {
        this.curIndex = 0
        this.show = true
      },
      dropdownChange() {

      },
      onConfirm(e) {
        this.type = e
        this.show = false
        this.calcActive()
        console.log(e)
      },
      paixuzuzhuang(optionarr, answerarr) {
        for (let i = 0; i < answerarr.length; i++) {
          for (let z = 0; z < optionarr.length; z++) {
            if (optionarr[z].optionid == answerarr[i]) {
              optionarr[z].xl = i + 1;
              break;
            }
          }
        }
      },
      back() {
        this.$router.push('/studentmain');
      },
      async tjanswerinfo() {
        this.doanswer = 0;
        this.undoanswer = 0;
        this.imgsuptotal = 0;
        this.imgsupsucess = [];
        this.imgsupsucnum = 0;
        this.dts =0;
        this.wdts = 0;
        for (let i = 0; i < this.data.length; i++) {
          for (let j = 0; j < this.data[i].PaperInfotabList.length; j++) {
            if(this.data[i].PaperInfotabList[j].isdc)
            {
              this.dts++;
            }
            else
            {
              this.wdts++;
            }
            if (!sf.isEmpty(this.data[i].PaperInfotabList[j].examansws) && this.data[i].PaperInfotabList[j].examansws != null) {
              this.doanswer++;
              //检查图片视频音频是否上传成功
              if (this.data[i].PaperInfotabList[j].examTypeId != "1" &&
                this.data[i].PaperInfotabList[j].examTypeId != "2" &&
                this.data[i].PaperInfotabList[j].examTypeId != "3" &&
                this.data[i].PaperInfotabList[j].examTypeId != "4" &&
                this.data[i].PaperInfotabList[j].examTypeId != "8") {
                let isimg=false;
                for (let m = 0; m < this.data[i].PaperInfotabList[j].examansws.length; m++) {
                  if (this.data[i].PaperInfotabList[j].examansws[m].url != undefined) {
                    this.imgsuptotal++;
                    if (!sf.isEmpty(this.data[i].PaperInfotabList[j].examansws[m].url)) {
                      this.imgsupsucnum++;
                      isimg = true;
                    }
                  }
                }
                if(isimg)
                {
                  this.imgsupsucess.push({examcont:this.data[i].PaperInfotabList[j].examCont,imagedata:this.data[i].PaperInfotabList[j].examansws})
                }
              }
            } else {
              if (this.data[i].PaperInfotabList[j].examtypeid != "6") {
                this.undoanswer++;
                this.wdtype = i;
                this.wdtindex = j;
                console.log("未达题答案："+this.data[i].PaperInfotabList[j].examansws);
              }
            }
            if (!sf.isEmpty(this.data[i].PaperInfotabList[j].ljttabList) && this.data[i].PaperInfotabList[j].ljttabList != null) {
              for (let l = 0; l < this.data[i].PaperInfotabList[j].ljttabList.length; l++) {
                if (!sf.isEmpty(this.data[i].PaperInfotabList[j].ljttabList[l].examansws) && this.data[i].PaperInfotabList[j].ljttabList[l].examansws != null) {
                  this.doanswer++;
                  let isimg=false;
                  //检查理解图片视频音频上传
                  if (this.data[i].PaperInfotabList[j].ljttabList[l].examTypeId != "1" &&
                    this.data[i].PaperInfotabList[j].ljttabList[l].examTypeId != "2" &&
                    this.data[i].PaperInfotabList[j].ljttabList[l].examTypeId != "3" &&
                    this.data[i].PaperInfotabList[j].ljttabList[l].examTypeId != "4" &&
                    this.data[i].PaperInfotabList[j].examtypeid != "8") {
                    for (let m = 0; m < this.data[i].PaperInfotabList[j].ljttabList[l].examansws.length; m++) {
                      if (this.data[i].PaperInfotabList[j].ljttabList[l].examansws[m].url != undefined) {
                        this.imgsuptotal++;
                        if (!sf.isEmpty(this.data[i].PaperInfotabList[j].ljttabList[l].examansws[m].url)) {
                          this.imgsupsucnum++;
                          isimg = true;
                        }
                      }
                    }
                    if(isimg)
                    {
                      this.imgsupsucess.push({examcont:this.data[i].PaperInfotabList[j].ljttabList[l].examCont,imagedata:this.data[i].PaperInfotabList[j].ljttabList[l].examansws})
                    }
                  }
                } else {
                  this.undoanswer++;
                  this.wdtype = i;
                  this.wdtindex = j;
                }
              }
            }
          }
        }
      },
      sucimgs(){
        this.dialogshow=false;
        this.dialogimgsshow=true;
      },
      closeimgshow(){
        this.dialogimgsshow=false;
      },
      beforeperjiaojuanClose(action, done){
        if(action === 'confirm') {
          this.$router.push('/zaixianlianxi');
          done()
        } else if(action === 'cancel') {
          this.$router.push('/studentmain');
          done() //关闭
        }
      },

      choseanswer: function(tj) {
        if(tj == 'no')
        {
          if(this.wdtindex!=1111 && this.wdtype !=1111)
          {
            this.type.value = this.wdtype
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive();
            this.curIndex = this.wdtindex;
          }
        }
        else
        {
          this.alterNum('next');
        }
      },
      popupshow: function() {
        this.popshow = true;
        this.tjanswerinfo();

      },
      async prejiaojuan() {
        if (this.jiaojuaning) {
          this.$toast.fail('正在交卷中，不要重复点击');
          return;
        }
        let timsg=await this.tjanswerinfo();
        this.dialogshow=true;
      },
      paramstr: function()
      {
        let params = {};
        return params
      },
      jaojuan: function() {

      },
      saveanswer: function() {
        this.tjanswerinfo();
        let params = this.paramstr();
        console.log(params);
        console.log("redisdata:",params.typeoption)
      }
    }
  }
</script>
<style lang="scss">
  .main{
    .title{
      i{
        margin-left: .1875rem;
      }
    }
    i.van-icon-clock{
      margin-right: .1875rem;
    }
    .name-num{
      margin: 0 .625rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: .0625rem dashed rgb(235, 234, 234);
      span{
        font-size: 1.875rem;
        color: #7469F8;
      }
    }
    .content{
      padding: 0 .625rem;
    }
  }
  .imgshowdiv{
    position: fixed;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;

    z-index: 555;
  }
  .facelayer {
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 999;
  }
  .jjclass{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/studentpage/lianxiindex.vue